import { __awaiter } from "tslib";
import { text, isValidInput } from "@phoenixreisen/form";
import { resetPhxPasswordViaEmail } from "../model";
import m from "mithril";
const Link = m.route.Link;
const reset = (state, e) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { username } = state.fields;
    (_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
    if (isValidInput(state.fields)) {
        state.error = null;
        state.submitting = true;
        yield resetPhxPasswordViaEmail(username.value())
            .then(() => m.route.set("/zurueckgesetzt/email"))
            .catch((result) => {
            state.error = result;
            state.submitting = false;
            m.redraw();
        });
    }
});
export default class {
    oninit({ state }) {
        state.error = null;
        state.submitting = false;
        state.fields = {
            username: text(true, (input) => {
                state.error = null;
                return input;
            }),
        };
    }
    view({ state }) {
        const { fields, error, submitting } = state;
        const { username } = fields;
        return (m("form", { class: "form login-form pa2", onsubmit: (e) => reset(state, e) },
            m("p", null, "Sofern deine Emailadresse in der Datenbank hinterlegt ist, bekommst du einen Link zugeschickt, der dich f\u00FCr einige Zeit einloggt, damit du dir ein neues Passwort setzen kannst."),
            error && (m("div", { class: "alert alert--danger" }, error["userfriendly-message"] ||
                error["details"] ||
                `Dein Passwort konnte nicht zurückgesetzt werden. Bitte
                        prüfe deine Eingabe und melde dich im Zweifel bei der IT`)),
            m("div", null,
                m("label", { class: "textfield" },
                    m("input", { type: "text", name: "username", maxLength: "100", autocomplete: "username", placeholder: "z.B. Fabian", value: username.value(), oninput: (e) => username.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${username.complaint ? "alert--warning" : ""}` }, "Dein Benutzername"))),
            m("div", { class: "flex justify-between items-center" },
                m("button", { type: "submit", disabled: submitting, class: "ma0" },
                    submitting ? m("i", { class: "fas fa-spinner fa-spin mr2" }) : "",
                    "Link schicken"),
                m(Link, { href: "/", title: "zur\u00FCck zur Anmeldung", class: "btn btn--link ma0 ml2" },
                    m("i", { class: "fas fa-home mr1" }),
                    " Login"))));
    }
}
